import { ListeningPackage, ListeningPackageType, PackageThumbnail, UserListeningPackagesResponse } from '../../common/services/package/package.model';
import PackageService from '../../common/services/package/package.service';
import NoAuthService from './noauth.service';

/* @ngInject */
export default class NoAuthPackagesService {
    constructor(
        private noAuthService: NoAuthService,
        private packageService: PackageService
    ) { }

    public convertListeningPackage(listeningPackage: ListeningPackage): PackageThumbnail {
        return this.packageService.convertListeningPackage(listeningPackage);
    }

    public filterOfferables(packages: UserListeningPackagesResponse, gsmOperator): ListeningPackage[] {
        var offerables: ListeningPackage[] = [];
        var onUser = false;

        packages.offerablePackages.forEach(offerable => {
            if (offerable.type === ListeningPackageType.CREDITCARD) {
                packages.userListeningPackages.forEach(userListeningPackage => {
                    if (userListeningPackage.listeningPackage.offerId === offerable.offerId) {
                        onUser = true;
                        return;
                    }
                });
                if (!onUser) {
                    offerables.push(offerable);
                }
                onUser = false;
            }
        });

        return offerables;
    }

    public async checkUser(msisdn: string) {
        var res = "error.message.default";
        await this.noAuthService.checkOrCreateUser(msisdn).then(userResult => {
            if (userResult) {
                res = "";
            }
        });
        return res;
    }

    public async getFilteredUserPackages(msisdn: string) {
        var ulp: UserListeningPackagesResponse;
        await this.noAuthService.listPackages(msisdn).then(async packagesResult => {
            ulp = packagesResult;
            await this.noAuthService.isTurkcellSubscriber(msisdn).then(gsmResult => {
                ulp.offerablePackages = this.filterOfferables(packagesResult, gsmResult);
            });
        });
        return ulp;
    }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/services/noauth-packages.service.ts